<template>
  <div class="field_report_details_holder">
    <div class="field_report_details_spacer"></div>
    <div class="info_line">
      <div class="info_value">{{ "Data" }}</div>
      <div class="info_quantity">{{ fieldReportData?.date ? formatDate(fieldReportData.date) : "-" }}</div>
    </div>
    <div class="info_line">
      <div class="info_value">{{ "Parcele" }}</div>
      <div class="info_quantity">{{ fieldReportData?.parcel_names?.length > 0 ? fieldReportData.parcel_names.join(", ") : "-" }}</div>
    </div>
     <div class="info_line">
      <div class="info_value">{{ "Locul încărcării" }}</div>
      <div class="info_quantity">{{ fieldReportData?.uploading_place ? fieldReportData.uploading_place : "-" }}</div>
    </div>
    <div class="info_line">
      <div class="info_value">{{ "Locul descărcării" }}</div>
      <div class="info_quantity">{{ fieldReportData?.unloading_place ? fieldReportData.unloading_place : "-" }}</div>
    </div>
    <div class="info_line">
      <div class="info_value">{{ "Șofer" }}</div>
      <div class="info_quantity">{{ fieldReportData?.document_data?.driver_name ? fieldReportData.document_data.driver_name : "-" }}</div>
    </div>
    <div class="info_line" v-if="!!fieldReportData.document_data.partner_uuid">
      <div class="info_value">{{ "Partener" }}</div>
      <div class="info_quantity">{{ fieldReportData?.document_data?.partner_name ?? "" }}</div>
    </div>
    <div class="info_line" v-if="!!fieldReportData.document_data.partner_uuid">
      <div class="info_value">{{ "Nr. Contract" }}</div>
      <div class="info_quantity">{{ fieldReportData?.contract_number ?? "-" }}</div>
    </div>
    <div class="info_line" v-if="fieldReportData.finished_weighing == 1">
      <div class="info_value">{{ "Greutate cântărită" }}</div>
      <div class="info_quantity">{{ fieldReportData && fieldReportData.netto_weight_kg ? parseFloat(fieldReportData.netto_weight_kg) : 0 }} {{ "kg" }}</div>
    </div>
    <div class="info_line" v-if="!!fieldReportData.field_delivery_note_document">
      <div v-if="fieldReportData.field_delivery_note_download_url" class="movement-document" @click="downloadDocument()">
        {{ "Descarcă" }} aviz de însoțire a mărfii
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "FieldReportDetails",
  props: {
    fieldReportData: [],
    selectionMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      getDefaultDateFormat: "settings/getDefaultDateFormat",
    }),
  },
  methods: {
    ...mapActions({
      getDownloadInfo: "smTransactions/getDownloadInfo",
      downloadPdf: "smTransactions/downloadPdf",
    }),
    formatDate(dateStr) {
      if (!dateStr) return "-";
      return moment(dateStr).format(this.getDefaultDateFormat);
    },
    downloadDocument() {
      this.downloadPdf({
        url: this.fieldReportData.field_delivery_note_download_url,
        filename: this.fieldReportData.field_delivery_note_download_filename,
        response_type: "blob",
      }).catch((e) => {
        console.log("preview download error: ", e.response);
        if (e.response.status === 400 || e.response.status === 500) {
          if (e.response.data.errors && e.response.data.errors.error) {
            this.$refs.toastMessage.showError("A apărut o eroare la descărcarea documentului! " + e.response.data.errors.error);
          } else {
            this.$refs.toastMessage.showError("A apărut o eroare la descărcarea documentului!");
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.movement-document {
  font-family: "Mulish";
  font-style: normal;
  letter-spacing: 0.02em;
  font-weight: Bold;
  color: #096c27;
  margin-top: 6px;
  font-size: 14px;
  text-decoration: underline;
}
</style>
